import { Loader } from '@googlemaps/js-api-loader'
import React, { useState } from 'react'

import { getRuntimeConfig } from '@front/runtime-config'

const {
  public: { googleApiKey },
} = getRuntimeConfig()

export const useGoogleMaps = () => {
  const autoCompleteService =
    React.useRef<google.maps.places.AutocompleteService>()
  const geocoder = React.useRef<google.maps.Geocoder>()
  const [isReady, setIsReady] = useState(false)

  React.useEffect(() => {
    const loader = new Loader({
      apiKey: googleApiKey,
      version: 'weekly',
      libraries: ['places'],
    })

    void Promise.all([
      loader.importLibrary('geocoding'),
      loader.importLibrary('places'),
    ]).then(([g, p]) => {
      autoCompleteService.current = new p.AutocompleteService()
      geocoder.current = new g.Geocoder()
      setIsReady(true)
    })
  }, [])

  const getPlacePredictions = React.useMemo(
    () => (request: google.maps.places.AutocompletionRequest) => {
      return (
        autoCompleteService.current?.getPlacePredictions(request) ??
        Promise.resolve({
          predictions: [],
        })
      )
    },
    [],
  ) as unknown as (
    request: google.maps.places.AutocompletionRequest,
  ) => google.maps.places.AutocompleteResponse

  const geocode = React.useCallback(
    async (request: google.maps.GeocoderRequest) => {
      const geocode = geocoder.current?.geocode
      if (!geocode) {
        return Promise.resolve([])
      }
      const { results } = await geocode(request)
      return Promise.resolve(results)
    },
    [],
  )

  return {
    getPlacePredictions,
    geocode,
    isReady,
  }
}
